import { render, staticRenderFns } from "./UserInfoMenu.vue?vue&type=template&id=7cf1f22e"
import script from "./UserInfoMenu.vue?vue&type=script&lang=js"
export * from "./UserInfoMenu.vue?vue&type=script&lang=js"
import style0 from "./UserInfoMenu.vue?vue&type=style&index=0&id=7cf1f22e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports